import { ChangeDetectionStrategy, Component, CUSTOM_ELEMENTS_SCHEMA, model } from '@angular/core';
import { ButtonComponent } from '@skylab-angular-shared/ui';

@Component({
	selector: 'skl-navigation-button',
	template: `
		<skl-button
			data-kind="icon-only"
			typeName="transparent"
			[class.open]="open()"
			[attr.aria-expanded]="open()"
			aria-label="Toggle navigation"
			(click)="open.set(!open())"
		>
			<div class="toggle-icon">
				<span class="hamburger-line"></span>
				<span class="hamburger-line"></span>
				<span class="hamburger-line"></span>
			</div>
		</skl-button>
	`,
	styles: `
		:host {
			--_toggle-icon-color: white;
			--_toggle-button-color: var(--primary-color);
			--_toggle-button-color-hover: rgb(0 0 0 / 10%);

			display: contents;
		}

		.toggle-icon {
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;
		}

		.hamburger-line {
			display: block;
			inline-size: 1.5rem;
			block-size: 2px;
			border-radius: 2px;
			margin-block-end: 5px;
			background-color: var(--_toggle-icon-color);
			will-change: transform, opacity;
			transition:
				transform 0.4s cubic-bezier(0.77, 0.2, 0.05, 1),
				opacity 0.3s ease,
				background-color 0.3s ease;

			&:last-child {
				margin-block-end: 0;
			}
		}

		@media only screen and (max-width: 60rem) {
			.open .hamburger-line {
				&:first-child {
					transform: rotate(45deg) translate(5px, 5px);
				}

				&:nth-child(2) {
					opacity: 0;
					transform: scale(0.2);
				}

				&:last-child {
					transform: rotate(-45deg) translate(5px, -5px);
				}
			}
		}
	`,
	schemas: [CUSTOM_ELEMENTS_SCHEMA],
	imports: [ButtonComponent],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavigationButtonComponent {
	readonly open = model(false);
}
